import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'

export function NotFound() {
  return (
    <div className="min-h-[calc(100vh-8rem)] flex flex-col items-center justify-center px-4">
      <Helmet>
        <title>Page Not Found | VaultLynk</title>
        <meta name="description" content="The page you are looking for does not exist or has been moved." />
      </Helmet>
      <h1 className="text-8xl font-bold text-gradient mb-4">404</h1>
      <h2 className="text-2xl font-semibold text-gray-900 mb-2">Page Not Found</h2>
      <p className="text-gray-600 mb-8 text-center max-w-md">
        The page you are looking for does not exist or has been moved.
      </p>
      <Link
        to="/"
        className="btn-primary btn-md"
      >
        Go Home
      </Link>
    </div>
  )
}
